import { render, staticRenderFns } from "./ButtonSmall.vue?vue&type=template&id=d9dc84ba&"
import script from "./ButtonSmall.vue?vue&type=script&lang=js&"
export * from "./ButtonSmall.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSmall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports